import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import { useResponsive } from "../../contexts";
import { useStore } from "../../../store/store-context";
import TryAnchorBanner from "../TryAnchorBanner/TryAnchorBanner";
import SignedAgreement from "./SignedAgreement.json";
import styles from "./SignedAgreementAnimationWrapper.module.scss";
import { useIoContext } from "../../../contexts";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SignedAgreementAnimationWrapper = _ref => {
  let {
    children,
    dataTestId
  } = _ref;
  const [showBanner, setShowBanner] = useState(false);
  const [contentShift, setContentShift] = useState(false);
  const [shouldTransform, setShouldTransform] = useState(false);
  const {
    isDesktop
  } = useResponsive();
  const pageRef = useRef(null);
  const contentRef = useRef(null);
  const hasAVendorAccount = !!useStore(state => {
    var _state$userInfo;
    return (_state$userInfo = state.userInfo) === null || _state$userInfo === void 0 ? void 0 : _state$userInfo.hasAVendorAccount();
  });
  const {
    Lottie
  } = useIoContext();
  useEffect(() => {
    const calculateTransform = () => {
      var _pageRef$current$getB, _pageRef$current, _contentRef$current$g, _contentRef$current;
      const pageHeight = (_pageRef$current$getB = (_pageRef$current = pageRef.current) === null || _pageRef$current === void 0 ? void 0 : _pageRef$current.getBoundingClientRect().height) !== null && _pageRef$current$getB !== void 0 ? _pageRef$current$getB : 0;
      const contentHeight = (_contentRef$current$g = (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.getBoundingClientRect().height) !== null && _contentRef$current$g !== void 0 ? _contentRef$current$g : 0;
      const topMargin = (pageHeight - contentHeight) / 2;
      const marginFromTop = isDesktop ? 64 + 16 + 16 : 100;
      setShouldTransform(topMargin === 0 || topMargin - marginFromTop > 0);
    };
    calculateTransform();
    window.addEventListener('resize', calculateTransform);
    return () => window.removeEventListener('resize', calculateTransform);
  }, [isDesktop]);
  const handleLottieComplete = () => {
    setContentShift(!hasAVendorAccount);
    setTimeout(() => setShowBanner(true), 300);
  };
  return /*#__PURE__*/_jsxs("div", {
    ref: pageRef,
    style: {
      minHeight: '100%',
      width: '100%',
      display: 'flex',
      justifyContent: shouldTransform ? 'center' : 'flex-start',
      alignItems: 'center',
      flexDirection: 'column'
    },
    "data-testid": dataTestId,
    className: styles.animationWrapper,
    children: [/*#__PURE__*/_jsx(motion.div, {
      animate: contentShift && shouldTransform ? {
        y: -64
      } : {
        y: 0
      },
      transition: {
        duration: 0.3,
        ease: 'easeInOut'
      },
      children: /*#__PURE__*/_jsxs("div", {
        ref: contentRef,
        style: {
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        },
        children: [/*#__PURE__*/_jsx(Lottie, {
          animationData: SignedAgreement,
          className: styles.signedAgreement,
          loop: false,
          onComplete: handleLottieComplete
        }), children]
      })
    }), !hasAVendorAccount && /*#__PURE__*/_jsx(TryAnchorBanner, {
      showBanner: showBanner,
      isFixed: shouldTransform
    })]
  });
};
export default SignedAgreementAnimationWrapper;